export default __webpack_public_path__ + "static/annotation-hn-dark-mode-31cb18bd5bd41cccbbbf5a0befafa0b1.png";